import axios from "axios";

const apiClient = axios.create({
  baseURL: 'https://solutions.fusepong.com/api/',
  //baseUrl: 'https://newsolutions.fusepong.com/api/',
  // baseURL: 'https://staging.fusepong.com/api/',
  //baseUrl: 'http://localhost:4000/api/',
  //baseUrl: 'http://192.168.0.78:3000/api/',
  headers: {
    "Access-Control-Allow-Origin": '*',
    "Accept-Language": 'es',
    "Access-Control-Allow-Methods": 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    "Access-Control-Allow-Headers": 'Origin, Content-Type, Authentication, Accept-Language',
    "Access-Control-Max-Age": '1728000',
    "Content-Type": 'application/json',
  }
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const deviceId = localStorage.getItem('device_id');
    if (deviceId) {
      config.headers['X-Device-ID'] = deviceId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

export default apiClient;